exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fontStyle[data-v-e7a032fc]{font-size:12px}.errorStyle[data-v-e7a032fc]{font-weight:bolder;color:red}", ""]);

// exports
